import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledButton = styled(Button)`
    padding: 5px;
    min-width: 22px;
`;

const LayerIconSvg = styled('svg')`
    width: 22px;
    height: 22px;
`;

export type LayerButtonProps = {
    onMoveToBack: () => void;
    onMoveToFront: () => void;
    onMoveBackward: () => void;
    onMoveForward: () => void;
};

const svgs = {
    moveToBack:
        <>
            <path
                d="M18 7.333C18 6.597 17.403 6 16.667 6H7.333C6.597 6 6 6.597 6 7.333v9.334C6 17.403 6.597 18 7.333 18h9.334c.736 0 1.333-.597 1.333-1.333V7.333z"
                fill="#ffa94d" stroke="#ffa94d" strokeWidth="2"></path>
            <path
                d="M11 3a1 1 0 00-1-1H3a1 1 0 00-1 1v7a1 1 0 001 1h8V3zM22 14a1 1 0 00-1-1h-7a1 1 0 00-1 1v7a1 1 0 001 1h8v-8z"
                fill="var(--icon-fill-color)" stroke="var(--icon-fill-color)" strokeWidth="2"></path>
        </>,
    moveBackward:
        <>
            <path
                d="M16 3.556C16 2.696 15.303 2 14.444 2H3.556C2.696 2 2 2.697 2 3.556v10.888C2 15.304 2.697 16 3.556 16h10.888c.86 0 1.556-.697 1.556-1.556V3.556z"
                fill="#ffa94d" stroke="#ffa94d" strokeWidth="2"></path>
            <path
                d="M22 9.556C22 8.696 21.303 8 20.444 8H9.556C8.696 8 8 8.697 8 9.556v10.888C8 21.304 8.697 22 9.556 22h10.888c.86 0 1.556-.697 1.556-1.556V9.556z"
                fill="var(--icon-fill-color)" stroke="var(--icon-fill-color)" strokeWidth="2"></path>
        </>,
    moveToFront:
        <>
            <path
                d="M13 21a1 1 0 001 1h7a1 1 0 001-1v-7a1 1 0 00-1-1h-3v5h-5v3zM11 3a1 1 0 00-1-1H3a1 1 0 00-1 1v7a1 1 0 001 1h3V6h5V3z"
                fill="var(--icon-fill-color)" stroke="var(--icon-fill-color)" strokeWidth="2"></path>
            <path
                d="M18 7.333C18 6.597 17.403 6 16.667 6H7.333C6.597 6 6 6.597 6 7.333v9.334C6 17.403 6.597 18 7.333 18h9.334c.736 0 1.333-.597 1.333-1.333V7.333z"
                fill="#ffa94d" stroke="#ffa94d" strokeWidth="2"></path>
        </>,
    moveForward:
        <>
            <path
                d="M22 9.556C22 8.696 21.303 8 20.444 8H16v8H8v4.444C8 21.304 8.697 22 9.556 22h10.888c.86 0 1.556-.697 1.556-1.556V9.556z"
                fill="var(--icon-fill-color)" stroke="var(--icon-fill-color)" strokeWidth="2"></path>
            <path
                d="M16 3.556C16 2.696 15.303 2 14.444 2H3.556C2.696 2 2 2.697 2 3.556v10.888C2 15.304 2.697 16 3.556 16h10.888c.86 0 1.556-.697 1.556-1.556V3.556z"
                fill="#ffa94d" stroke="#ffa94d" strokeWidth="2"></path>
        </>
};

export const LayerButtons = (props: LayerButtonProps) => {
    const { t } = useTranslation('whiteboard');

    const { onMoveToBack, onMoveToFront, onMoveBackward, onMoveForward } = props;

    return (
        <Stack spacing={1} direction="row">
            <StyledButton variant="contained" color="inherit" className="option-button" onClick={onMoveToBack} title={t('send-to-back')}>
                <LayerIconSvg aria-hidden="true" focusable="false" role="img" viewBox="0 0 24 24" className="rtl-mirror">
                    {svgs.moveToBack}
                </LayerIconSvg>
            </StyledButton>
            <StyledButton variant="contained" color="inherit" className="option-button" onClick={onMoveBackward} title={t('send-backward')}>
                <LayerIconSvg aria-hidden="true" focusable="false" role="img" viewBox="0 0 24 24" className="rtl-mirror">
                    {svgs.moveBackward}
                </LayerIconSvg>
            </StyledButton>
            <StyledButton variant="contained" color="inherit" className="option-button" onClick={onMoveToFront} title={t('bring-to-front')}>
                <LayerIconSvg aria-hidden="true" focusable="false" role="img" viewBox="0 0 24 24" className="rtl-mirror">
                    {svgs.moveToFront}
                </LayerIconSvg>
            </StyledButton>
            <StyledButton variant="contained" color="inherit" className="option-button" onClick={onMoveForward} title={t('bring-forward')}>
                <LayerIconSvg aria-hidden="true" focusable="false" role="img" viewBox="0 0 24 24" className="rtl-mirror">
                    {svgs.moveForward}
                </LayerIconSvg>
            </StyledButton>
        </Stack>
    );
};
